export default {
  title: 'Swiss Engineers United', sections: {
    index_hero_section: {
      fields: {
        field_one: {
          value: {
            text: 'Führende Schweizer Engineering-Gruppe für erfolgreiche Zukunftsentwicklung und Nachfolgelösungen in Bau, Geomatik und Planung.',
            subtext: 'Durch den Kauf Ihres erfolgreichen Ingenieurunternehmens und die gemeinsame Weiterentwicklung in der Gruppe positionieren wir Ihr Unternehmen als Leuchtturm in der Engineering-Branche.',
            buttonLabel: 'Willkommen im Team',
            buttonLink: '/wir',
            desktop_image: '/seu/hero_summer_desktop.jpg',
            desktop_video: '/seu/hero_summer_desktop.mp4',
            mobile_image: '/seu/hero_summer_mobile.jpg',
            mobile_video: '/seu/hero_summer_mobile.mp4',
          }
        },
      }
    },

    index_about_section: {
      fields: {
        field_one: {
          value: {
            text1: 'Führende Schweizer  Engineering-Gruppe für  erfolgreiche  Zukunftsentwicklung und Nachfolgelösungen in Bau, Geomatik und Planung.',
            text2: 'Durch den Kauf Ihres erfolgreichen Ingenieurunternehmens und die gemeinsame Weiterentwicklung in der Gruppe positionieren wir Ihr Unternehmen als Leuchtturm in der Engineering-Branche.'
          }
        }
      }
    },

    index_features_2_section: {
      fields: {
        field_one: {
          value: {
            boxes: [{
              image: '/seu/latest-icons/engineering.svg',
              title: 'Engineering',
              subTitle: 'Wir sind führende Experten. <br/> Für Geomatik, Bau und Planung.',
              buttonLabel: 'ENGINEERING',
              buttonIcon: '/seu/arrow-right.svg',
              buttonLink: '/engineering'
            }, {
              image: '/seu/latest-icons/caracters.svg',
              title: 'Fachkräfte',
              subTitle: 'Wir schaffen Gesamtlösungen. <br/>Individuell und branchenweit.',
              buttonLabel: 'STRATEGIE',
              buttonIcon: '/seu/arrow-right.svg',
              buttonLink: '/strategie'
            }, {
              image: '/seu/latest-icons/handshake.svg',
              title: 'Nachfolgelösungen',
              subTitle: 'Wir führen Ihr Unternehmen weiter. Erfolgreich und langfristig.',
              buttonLabel: 'ANGEBOT',
              buttonIcon: '/seu/arrow-right.svg',
              buttonLink: '/angebot'
            },]
          }
        }
      }
    }, index_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Seu'
          }
        }
      }
    }, index_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_32.jpg'
          }
        }
      }
    }, index_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Von Ingenieuren </div> für Ingenieure'
          }
        }, field_two: {
          value: {
            text: 'Wir führen <br/> gesunde und innovative  <br/> Engineering-Unternehmen  <br/> in die Zukunft'
          }
        }, field_three: {
          value: {
            text: 'Wünschen Sie sich eine sichere und erfolgreiche Unternehmensnachfolge? Wir bieten Ihnen eine professionelle Lösung – unternehmerisch, weitsichtig, auf Augenhöhe. Und falls Zurücklehnen noch keine Option für Sie ist: dann freuen wir uns, wenn Sie mit Ihrer Expertise weiterhin an Bord bleiben.'
          }
        }, field_four: {
          value: {
            text: 'Werden Sie Co-Unternehmer/in der SEU: Durch Integration Ihrer Unternehmung als Partnerunternehmen. Gemeinsam navigieren wir Ihre Firma in die Zukunft und steuern Ihre Marke zum Erfolg.',
            text2: 'Sie profitieren von Anfang an von Synergieeffekten auf allen Ebenen. Immer genau dort, wo sie gebraucht werden: bei der Personalrekrutierung, in der Administration oder bei Engpässen in Projekten.',
            buttonLabel: 'Energie durch Synergie',
            buttonIcon: '/seu/arrow-right.svg',
            buttonLink: '/strategie'
          }
        },
      }
    }, index_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [{
              title: 'Ihre Vorteile als <br/> Co-Unternehmer/in bei der SEU',
              image: '/seu/latest-icons/thumbs-up.svg',
              values: [{
                name: 'Ihre Expertise wird Teil eines starken <br/> Netzwerkes mit nationaler Strahlkraft.'
              }, {
                name: 'Sie gestalten die Zukunft der SEU-Gruppe <br/> mit und sind am Erfolg beteiligt.'
              }, {
                name: 'Sie können sich auf eine erfolgreiche <br/> Nachfolgelösung verlassen.'
              },]
            }, {
              title: 'Ihre Vorteile als <br/> SEU-Partnerunternehmen',
              image: '/seu/latest-icons/circles.svg',
              values: [{
                name: 'Ihre Marke lebt weiter.'
              }, {
                name: 'Ihr Unternehmen behält operative Freiheit und Selbstständigkeit.'
              }, {
                name: 'Ihre Firma profitiert von Synergieeffekten und bleibt langfristig wettbewerbsfähig.'
              }]
            },

            ]
          }
        }
      }
    }, index_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Seu'
          }
        }
      }
    }, index_text2_section: {
      fields: {
        field_one: {
          value: {
            text: 'Wir bringen Innovationsgeist, Expertise und dynamisches Unternehmertum zusammen'
          }
        }, field_two: {
          value: {
            text: 'Swiss Engineers United ist die Plattform für Ingenieurinnen und Ingenieure von morgen. Wir sind eine Gruppe erfolgreicher Schweizer Ingenieur-Unternehmen aus den Bereichen <a href="/engineering" class="text-highlight"> Bau, Geomatik und Planung</a>.'
          }
        }, field_three: {
          value: {
            text: 'Für uns zählen Werte und Visionen mehr als die Grösse des Unternehmens: Wir beflügeln innovative Ideen, bringen Höchstleistungen auf den Markt und sind Vorreiter in Sachen Technologie, Methodik, Digitalisierung und Prozessoptimierung.',
            text2: 'Egal, ob Sie ein etabliertes KMU führen, einen Namen als profilierter Nischenspezialist geniessen, ausgewiesene Expertin sind oder gerade Ihr Start-up vergrössern möchten: Ihre Zukunft liegt uns am Herzen. Ihre Tatkraft ist bei uns in besten Händen. Ihre Ideen finden bei uns die passende Anhöhe zum Abheben.'
          }
        },
      }
    }, index_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'Wir freuen uns auf Sie:',
            text2: 'Let\'s engineer the future together!',
            buttonLabel: 'Schreiben Sie uns',
            buttonLink: 'mailto:verwaltungsrat@seu.ch',
            image: '/seu/latest-assets/seu_22.jpg'
          }
        },
      }
    },
  }
}
